<template>
  <div>
    <div class="dashboard-layout-2">
      <home-notification-card  title="은평구청 안전·보건 경영 시스템 " :disabled="myInfo.is_superuser >= 1 ? false : true"/>
      <community-healthinfo-card />
      <community-business-news-card />
      <community-work-news-card />
    </div>
    <div v-if="hasDashboardCharts" class="dashboard-layout-auto">
      <component v-for="chart in hasDashboardCharts" :is="chart" :dataType="dataType"/>
    </div>
    <div v-if="successLoadGraph && !hasDashboardCharts" class="dashboard-layout-auto">
      <donut-chart01 :dataType="dataType"/>
      <donut-chart02 :dataType="dataType"/>
      <donut-chart03 :dataType="dataType"/>
      <donut-chart04 :dataType="dataType" v-if="parseInt(projectId) !== 2"/>
      <donut-chart05 :dataType="dataType"/>
      <health-safety-budget-execution-rate-chart :data-type="dataType"/>
      <donut-chart06 :dataType="dataType"/>
      <donut-chart07 :dataType="dataType"/>
      <donut-chart08 :dataType="dataType"/>
      <donut-chart09 :dataType="dataType"/>
      <donut-chart10 :dataType="dataType"/>
      <donut-chart11 :dataType="dataType"/>
      <donut-chart12 :dataType="dataType"/>
      <donut-chart13 :dataType="dataType"/>
      <donut-chart14 :dataType="dataType"/>

      <!-- 시설물 점검 현황 -->
      <donut-chart16 :dataType="dataType"/>
      <!-- 시설물 진단 현황 -->
      <donut-chart17 :dataType="dataType"/>
      <!-- 시설물 보수 현황 -->
      <donut-chart18 :dataType="dataType"/>
      <!-- 시설물 보강 현황 -->
      <donut-chart19 :dataType="dataType"/>
      <!-- 시설물 교체 현황 -->
      <donut-chart20 :dataType="dataType"/>

    </div>
  </div>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import HomeNotificationCard from '@/components/HomeNotificationCard'
import CommunityHealthinfoCard from '@/components/CommunityHealthinfoCard'
import CommunityWorkNewsCard from '@/components/CommunityWorkNewsCard'
import CommunityBusinessNewsCard from '@/components/CommunityBusinessNewsCard'
import DonutChart01 from '@/views/graph/DonutChart01'
import DonutChart02 from '@/views/graph/DonutChart02'
import DonutChart03 from '@/views/graph/DonutChart03'
import DonutChart04 from '@/views/graph/DonutChart04'
import DonutChart05 from '@/views/graph/DonutChart05'
import DonutChart06 from '@/views/graph/DonutChart06'
import DonutChart07 from '@/views/graph/DonutChart07'
import DonutChart08 from '@/views/graph/DonutChart08'
import DonutChart09 from '@/views/graph/DonutChart09'
import DonutChart10 from '@/views/graph/DonutChart10'
import DonutChart11 from '@/views/graph/DonutChart11'
import DonutChart12 from '@/views/graph/DonutChart12'
import DonutChart13 from '@/views/graph/DonutChart13'
import DonutChart14 from '@/views/graph/DonutChart14'
import HealthSafetyBudgetExecutionRateChart from '@/views/graph/HeathSafetyBudgetExecutionRateChart'
import DonutChart16 from '@/views/graph/DonutChart16.vue'
import DonutChart17 from '@/views/graph/DonutChart17.vue'
import DonutChart18 from '@/views/graph/DonutChart18.vue'
import DonutChart19 from '@/views/graph/DonutChart19.vue'
import DonutChart20 from '@/views/graph/DonutChart20.vue'

export default {
  components: {
    DonutChart20,
    DonutChart19,
    DonutChart18,
    DonutChart17,
    DonutChart16,
    HealthSafetyBudgetExecutionRateChart,
    DonutChart14,
    DonutChart13,
    DonutChart12,
    DonutChart11,
    DonutChart10,
    DonutChart09,
    DonutChart08,
    DonutChart07,
    DonutChart06,
    DonutChart05,
    DonutChart04,
    DonutChart03,
    DonutChart02,
    DonutChart01,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard
  },
  data () {
    return {
      rootPath: '',
      successLoadGraph: false,
    }
  },
  async created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}`
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then(value => {
      this.successLoadGraph = true
    });;
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    myLv () {
      return parseInt(`${this.$store.state.auth.userInfo.position}`);
    },
    companyInfo () {
      return this.$store.state.auth.companyInfo
    },
    hasDashboardCharts () {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts
      if (hasDashboardCharts) {
        const list = []
        for (const chart of hasDashboardCharts) {
          if (chart.visible && Number(`${chart.project_id}`) === Number(`${this.projectId}`)) {
            list.push(chart.dashboard_chart.code)
          }
        }
        return list
      }

      return undefined
    },
    rootCompanyList () {
      const list = []
      for (const company of this.$store.state.company.companyList) {
        if (typeof company !== 'undefined' && typeof company.com_type !== 'undefined' && company.com_type === 'head') {
          list.push(company)
        }
      }
      return list
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    isAdmin () {
      let isAdmin = false
      const myInfo = this.$store.state.auth.userInfo
      for (const company of this.rootCompanyList) {
        if (myInfo.company_id === company.id) {
          isAdmin = true
          break;
        }
      }

      return isAdmin
    },
    comGroupList () {
      const companyTree = this.$store.state.company.companyTree
      let maxDepth = 0;
      const list = []
      let hasRootHead = false
      const headList = []

      if (companyTree && companyTree.length > 0) {
        for (const com of companyTree) {
          if(!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== 'undefined' && typeof com.descendant.com_type !== 'undefined' && com.descendant.com_type === 'head') {
            hasRootHead = true
            headList.push(com.descendant.com_name)
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth
          }

          const parentId = (com.descendant.parent_id) ? (com.descendant.parent_id) : com.descendant.id
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name
          } else {
            list[`com_${parentId}`] = {[com.descendant.id]: com.descendant.com_name}
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list
      }
    },
    dataType () {
      if (Number(`${this.comGroupList.maxDepth}`) === 0) {
        return 'detail'
      }
      return 'company'
    }
  },
  async mounted () {
    await this.loadCompanyList()
  },
  methods: {
    async loadCompanyList () {
      const page = 1
      const perPage = 10000
      const projectId = this.projectId
      await this.$store.dispatch('company/LOAD_COMPANY_TREE', {projectId})
      await this.$store.dispatch('company/LOAD_COMPANY_LIST', {
        page,
        perPage,
        comType: 'head',
        projectId
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
</style>
